// mui
import { Box } from '@mui/material';

// client-shared
import { display } from '@goldblack/client-utils';

import AdsenseAd from '../common/adsense-ad';

function BottomContent(props) {
    // Master ad switch (KV-configurable). When off, the bottom ad slot is not rendered.
    if (props.config?.allowAds === false) return null;
    return (
        <Box
            sx={{
                maxHeight: display.formatPxString(props.config.commonBottomMinHeight),
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexShrink: 0,
            }}>
            <AdsenseAd
                slotId={import.meta.env.VITE_ADSENSE_SLOT_BOTTOM}
                style={{ width: '100%', height: display.formatPxString(props.config.adsHeight) }}
                responsive={false}
            />
        </Box>
    );
}

export { BottomContent };
